import { Box, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import Sidebar from "../../layouts/sidebar";
import Header from "../../layouts/header";
import Layout from "../../layouts/layout";
import Index from "../objectionPaymentReport";
import { MdKeyboardArrowDown } from 'react-icons/md'
import { Link as MuiLink } from '@mui/material'
import { NavLink } from 'react-router-dom'
import Cookies from 'js-cookie'
import { cssProperties } from "../../utils/commonCssProperties";

export default function ObjectionPaymentReport() {
  const breadcrumbs = [
    <MuiLink underline="hover" key="1" component={NavLink} to={`/${Cookies.get('mhet_mst_project')}/home`} sx={{
        color: cssProperties?.fontcolor?.primary,
        fontSize: '14px',
        fontWeight: 400,
        lineHeight: '20px',
        letterSpacing: '0.1px'
    }}>
        Dashboard
    </MuiLink>,
    <Typography key="3" color="text.primary"
        sx={{
            display: 'flex', alignItems: 'center', gap: '12px', color: cssProperties?.fontcolor?.primary,
            fontSize: '14px',
            fontWeight: 500,
            lineHeight: '20px',
            letterSpacing: '0.1px'
        }}
    >
       Objection Payment Report <MdKeyboardArrowDown size={16} />
    </Typography>,
];
  return (
    <>
      <Sidebar />
      <Header breadcrumbs={breadcrumbs} />
      <Layout>
        <Index />
      </Layout>
    </>
  );
}
